module.exports = {
  PAGINATION: {
    PER_PAGE: 10,
    PAGE: 1,
  },
  MONEYPLANT_ADMIN:process.env.MONEYPLANT_ADMIN,
  BACKEND_API: process.env.REACT_APP_BACKEND_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  SECRET_KEY_TOKEN: process.env.REACT_APP_SECRET_KEY_TOKEN,
  TOKEN_EXPIRES_IN: process.env.REACT_APP_TOKEN_EXPIRES_IN,
  S3_BUCKET_BASE_URL: process.env.REACT_APP_AMZ_BUCKET_URL,
  COMPANY_NAME: process.env.REACT_APP_COMPANY_NAME,


  ADD_BALANCE_PARAMS:process.env.REACT_APP_ADD_BALANCE_PARAMS,
  CHECK_BALANCE_PARAMS:process.env.REACT_APP_CHECK_BALANCE_PARAMS,
  UPDATE_PASSOWRD_PARAMS:process.env.REACT_APP_UPDATE_PASSOWRD_PARAMS,
  GET_TRANSACTION_PARAMS:process.env.REACT_APP_GET_TRANSACTION_PARAMS,
  GET_DEAL_PARAMS:process.env.REACT_APP_GET_DEAL_PARAMS,
  REG_PARAMS:process.env.REACT_APP_REG_PARAMS,

  
  ROLES: {
    ADMIN: 1,
    USER: 7,
  },

  KYC_KEYS: {
    front: "Proof of Identity(POI)(Front)",
    back: "Proof of Identity(POI)(Back)",
    other: "Other",
    agreement: "Signed Agreement",
  },
};
